import { CommonModule } from '@angular/common';
import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { DesignAngularKitModule, ItModalComponent } from 'design-angular-kit';
import { FormDto } from '../../../../models/form.dto';
import { RequestDto } from '../../../../models/request.dto';
import { AuthService } from '../../../../services/auth.service';
import { EnrollementData } from '../../../../models/enrollement-data.model';

@Component({
  selector: 'app-form-row',
  standalone: true,
  imports: [CommonModule, DesignAngularKitModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './form-row.component.html',
  styleUrl: './form-row.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class FormRowComponent {

  @ViewChild(ItModalComponent) modal?: ItModalComponent;
  @Input() request!: RequestDto;
  @Input() form!: FormDto;
  @Input() readonly!: boolean;
  @Input() enrollementData: EnrollementData | undefined;

  @Output() formSelected = new EventEmitter<FormDto>();
  @Output() printForm = new EventEmitter<FormDto>();
  @Output() uploadAttachment = new EventEmitter<FormDto>();
  @Output() downloadAtachment = new EventEmitter<FormDto>();
  @Output() modify = new EventEmitter<FormDto>();
  @Output() delete = new EventEmitter<FormDto>();
  @Output() formStatusChanged = new EventEmitter<boolean>();

  modalId: string = `leftModal-${crypto.randomUUID()}`;

  showForm = false;
  formOpen = false;
  isSaving: boolean | undefined;

  constructor(public authService: AuthService) {}

  selectForm() {
    this.formSelected.emit(this.form);
  }

  selectFormAndPrint() {
    this.printForm.emit(this.form);
  }

  downloadAttachment() {
    this.downloadAtachment.emit(this.form);
  }
  modifyForm() {
    this.modify.emit(this.form);
  }
  deleteForm() {
    this.delete.emit(this.form);
  }
  uploadAllegato() {
    this.uploadAttachment.emit(this.form);
  }

}
